module.exports = __webpack_public_path__ + "static/media/book app.1c8e8e70.svg";